<div class="container">
    <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
        <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
        <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
            <label class="custom-control custom-checkbox chkbox mb-2" for="option1">
                <input type="checkbox" class="custom-control-input mgntp10" id="option1" value="Atleast one of us stays/works from home."
                    name="property" [(ngModel)]="hgType.opt1" (click)="getType($event)" />
                <label class="custom-control-label font20" for="option1">Atleast one of us stays/works from home</label>
            </label>
            <label class="custom-control custom-checkbox chkbox mb-2" for="option2">
                <input type="checkbox" class="custom-control-input mgntp10" id="option2" value='I/we work a regular "8 to 5" job.'
                    name="property" [(ngModel)]="hgType.opt2" (click)="getType($event)" />
                <label class="custom-control-label font20" for="option2">I/we work a regular "8 to 5" job</label>
            </label>
            <label class="custom-control custom-checkbox chkbox mb-2" for="option3">
                <input type="checkbox" class="custom-control-input mgntp10" id="option3" value="I/we only come home to sleep."
                    name="property" [(ngModel)]="hgType.opt3" (click)="getType($event)" />
                <label class="custom-control-label font20" for="option3">I/we only come home to sleep</label>
            </label>
            <label class="custom-control custom-checkbox chkbox mb-2" for="option4">
                <input type="checkbox" class="custom-control-input mgntp10" id="option4" value="Hard to tell. It/s different every day."
                    name="property" name="property" [(ngModel)]="hgType.opt4" (click)="getType($event)" />
                <label class="custom-control-label font20" for="option4">Hard to tell. It's different every day</label>
            </label>
            <label class="custom-control custom-checkbox chkbox mb-2" for="option5">
                <input type="checkbox" class="custom-control-input mgntp10" id="option5" value="Where is home? I mostly stay in hotels!"
                    name="property" [(ngModel)]="hgType.opt5" (click)="getType($event)" />
                <label class="custom-control-label font20" for="option5">Where is home? I mostly stay in hotels!</label>
            </label>
        </div>
        <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
        <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"
            (click)="next();">Next</button>
        <!-- <p class="text-success mt-3">{{questionObj.tip}}</p> -->

        <div class="mt-5">
            <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
                <img src="assets/images/flash.png" class="mb-1" />
                <p class="text-center tiphead">JUST SO YOU KNOW</p>
                <p class="text-center tipmes">{{questionObj.tip}}</p>
                <!-- <p class="text-center font-weight-bold">JUST SO YOU KNOW<br>
                <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
            </div>
        </div>
    </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row col-sm-12 m-auto">
        <label class="custom-control custom-checkbox chkbox mb-2" for="option1_mob">
            <input type="checkbox" class="custom-control-input mgntp10" id="option1_mob" value="Atleast one of us stays/works from home."
                name="property" [(ngModel)]="hgType.opt1" (click)="getType($event)" />
            <label class="custom-control-label font20" for="option1_mob">Atleast one of us stays/works from home</label>
        </label>
        <label class="custom-control custom-checkbox chkbox mb-2" for="option2_mob">
            <input type="checkbox" class="custom-control-input mgntp10" id="option2_mob" value='I/we work a regular "8 to 5" job.'
                name="property" [(ngModel)]="hgType.opt2" (click)="getType($event)" />
            <label class="custom-control-label font20" for="option2_mob">I/we work a regular "8 to 5" job</label>
        </label>
        <label class="custom-control custom-checkbox chkbox mb-2" for="option3_mob">
            <input type="checkbox" class="custom-control-input mgntp10" id="option3_mob" value="I/we only come home to sleep."
                name="property" [(ngModel)]="hgType.opt3" (click)="getType($event)" />
            <label class="custom-control-label font20" for="option3_mob">I/we only come home to sleep</label>
        </label>
        <label class="custom-control custom-checkbox chkbox mb-2" for="option4_mob">
            <input type="checkbox" class="custom-control-input mgntp10" id="option4_mob" value="Hard to tell. It/s different every day."
                name="property" name="property" [(ngModel)]="hgType.opt4" (click)="getType($event)" />
            <label class="custom-control-label font20" for="option4_mob">Hard to tell. It's different every day</label>
        </label>
        <label class="custom-control custom-checkbox chkbox mb-2" for="option5_mob">
            <input type="checkbox" class="custom-control-input mgntp10" id="option5_mob" value="Where is home? I mostly stay in hotels!"
                name="property" [(ngModel)]="hgType.opt5" (click)="getType($event)" />
            <label class="custom-control-label font20" for="option5_mob">Where is home? I mostly stay in hotels!</label>
        </label>
        <br />
        <p class="m-auto mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
        <div style="width:97% !important; text-align: right;">
            <div *ngIf="user_bot" class="ash_box text-right mb-1" >
                <h1 class="ansMob text-right">{{hoursSpend}}</h1>
            </div>
        </div>
        <!-- <div *ngIf="showTip"> -->
        <div class="col-12 px-0 mt-2">
            <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
                <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
                <p class="text-center tiphead">JUST SO YOU KNOW</p>
                <p class="text-center tipmes">{{questionObj.tip}}</p>
                <!-- <p class="text-center font-weight-bold">JUST SO YOU KNOW<br>
                    <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
            </div>
        </div>
        <!-- </div> -->
    </div>
</div>
<!-- <div class="btm-process webview">  
    <div class="text-center" *ngIf="!messagetype">
      <span><img src="assets/images/active17.png"></span>
      <h4 class="clr333 processtxt">15% Completed</h4>
    </div>
    <div class="text-center" *ngIf="messagetype">
        <span><img src="assets/images/active13.png"></span>
        <h5 class="clr333 processtxt">65% Completed</h5>
      </div>
  </div> -->